import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import SEO from "@/components/SEO";
import { Button } from "@/components/ui/button";

export default function ValidationSupport() {
  return (
    <>
      <SEO
        title="Validation Documentation Support for Regulated Labs | LabComplyx"
        description="Accelerate IQ/OQ/PQ and method validation documentation with governed workflows, human review, and audit-ready outputs. Built for labs under compliance pressure."
        canonical="https://labcomplyx.com/solutions/validation-support"
        breadcrumbs={[
          { name: "Home", url: "https://labcomplyx.com/" },
          { name: "Solutions", url: "https://labcomplyx.com/solutions" },
          { name: "Validation Support", url: "https://labcomplyx.com/solutions/validation-support" },
        ]}
      />
      <div className="pt-24">
        <section className="pb-16 bg-background">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 max-w-2xl">
            <span className="inline-block text-xs font-semibold text-secondary bg-secondary/10 px-3 py-1 rounded-full mb-4">Solution</span>
            <h1 className="text-4xl sm:text-5xl font-bold text-foreground mb-5">Validation documentation that moves faster and holds up</h1>
            <p className="text-lg text-muted-foreground leading-relaxed mb-8">
              LabComplyx accelerates validation documentation — IQ/OQ/PQ protocols, method validation, and verification records — with governed processes and human review built in.
            </p>
            <Link to="/ValidationIntake"><Button size="lg" className="gap-2">Discuss Your Validation Backlog <ArrowRight className="w-4 h-4" /></Button></Link>
          </div>
        </section>

        <section className="py-16 bg-muted/30 border-y border-border">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-12">
              <div>
                <h2 className="text-2xl font-bold text-foreground mb-5">Validation documentation bottlenecks</h2>
                <ul className="space-y-2.5">
                  {["IQ/OQ/PQ backlogs delaying equipment release", "Method validation records missing key acceptance criteria", "Protocols not aligned to current regulatory expectations", "No standardized template or review process", "Human error in manual protocol generation"].map((b) => (
                    <li key={b} className="flex items-start gap-2.5 text-sm text-muted-foreground"><span className="w-1.5 h-1.5 rounded-full bg-destructive shrink-0 mt-1.5" />{b}</li>
                  ))}
                </ul>
              </div>
              <div className="bg-card border border-border rounded-xl p-7">
                <h3 className="font-semibold text-foreground mb-4">LabComplyx validation support</h3>
                <ul className="space-y-2.5">
                  {["IQ/OQ/PQ protocol generation with acceptance criteria", "Method validation and verification documentation", "Governed drafting with validation-specific guardrails", "Human review and approval before any protocol is final", "Version control and audit trail captured throughout"].map((b) => (
                    <li key={b} className="flex items-start gap-2.5 text-sm text-muted-foreground"><Check className="w-4 h-4 text-secondary shrink-0 mt-0.5" />{b}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}